// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.todo-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.todo-header {
  margin-bottom: 2rem;
}

.todo-header h2 {
  margin: 0 0 0.5rem 0;
  color: #333;
  font-size: 2rem;
  font-weight: 700;
}

.todo-header p {
  margin: 0;
  color: #666;
  font-size: 1rem;
}

.todo-submenu {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #e0e0e0;
}

.todo-submenu-button {
  padding: 0.75rem 1.5rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: #666;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: -2px;
}

.todo-submenu-button:hover {
  color: #667eea;
  background: #f5f5f5;
}

.todo-submenu-button.active {
  color: #667eea;
  border-bottom-color: #667eea;
  font-weight: 600;
}

.todo-content {
  width: 100%;
}

.todo-add-section {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.todo-add-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s ease;
}

.todo-add-input:focus {
  outline: none;
  border-color: #667eea;
}

.todo-add-button {
  padding: 0.75rem 2rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.todo-add-button:hover {
  background: #5568d3;
}

.todo-items-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.todo-item {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
  overflow: hidden;
}

.todo-item.expanded {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.todo-item.completed {
  opacity: 0.8;
  background: #f9f9f9;
}

.todo-item.changelog-item {
  background: #f5f5f5;
  border-left: 4px solid #667eea;
}

.todo-item-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.todo-item-header:hover {
  background: #f9f9f9;
}

.todo-item-checkbox-wrapper {
  display: flex;
  align-items: center;
}

.todo-item-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #667eea;
}

.todo-item-title-wrapper {
  flex: 1 1;
  min-width: 0;
}

.todo-item-title-container {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.todo-item-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #333;
  word-wrap: break-word;
}

.todo-item-date-inline {
  font-size: 0.85rem;
  color: #999;
  font-style: italic;
}

.todo-item.completed .todo-item-title {
  text-decoration: line-through;
  color: #999;
}

.todo-item.changelog-item .todo-item-title {
  text-decoration: none;
  color: #333;
}

.todo-edit-title-input {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #667eea;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: 500;
}

.todo-item-priority {
  display: flex;
  align-items: center;
}

.todo-priority-select {
  padding: 0.5rem 1rem;
  border: 2px solid #e0e0e0;
  border-left: 4px solid #666;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.todo-priority-select:focus {
  outline: none;
  border-color: #667eea;
}

.todo-item-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.todo-edit-button,
.todo-save-button,
.todo-cancel-button,
.todo-close-button,
.todo-delete-button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.todo-edit-button {
  background: #667eea;
  color: white;
}

.todo-edit-button:hover {
  background: #5568d3;
}

.todo-save-button {
  background: #4caf50;
  color: white;
}

.todo-save-button:hover {
  background: #45a049;
}

.todo-cancel-button {
  background: #999;
  color: white;
}

.todo-cancel-button:hover {
  background: #777;
}

.todo-close-button {
  background: #ff9800;
  color: white;
}

.todo-close-button:hover {
  background: #f57c00;
}

.todo-delete-button {
  background: #d32f2f;
  color: white;
}

.todo-delete-button:hover {
  background: #b71c1c;
}

.todo-item-details {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
}

.todo-item-description {
  color: #666;
  line-height: 1.6;
}

.todo-item-description p {
  margin: 0;
}

.todo-no-description {
  font-style: italic;
  color: #999;
}

.todo-edit-description-input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #667eea;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
}

.todo-edit-description-input:focus {
  outline: none;
  border-color: #667eea;
}

.todo-changelog-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.todo-changelog-description {
  color: #666;
  line-height: 1.6;
}

.todo-changelog-description p {
  margin: 0;
}

.todo-changelog-date {
  font-size: 0.9rem;
  color: #999;
  font-style: italic;
}

.todo-empty-state {
  text-align: center;
  padding: 3rem 2rem;
  color: #666;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.loading, .error {
  text-align: center;
  padding: 3rem 2rem;
  font-size: 1.1rem;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
  border-radius: 4px;
  border: 1px solid #ffcdd2;
}


.todo-changelog-table {
  table-layout: fixed;
}

@media (max-width: 768px) {
  .todo-container {
    padding: 1rem;
  }

  .todo-item-header {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .todo-item-actions {
    flex-wrap: wrap;
  }

  .todo-priority-select {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
}

/* Changelog search */
.changelog-search-container {
  margin-bottom: 1.5rem;
  padding: 0;
}

.changelog-search-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.changelog-search-input:focus {
  outline: none;
  border-color: #667eea;
}

.changelog-search-input::placeholder {
  color: #999;
}

`, "",{"version":3,"sources":["webpack://./src/Todo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;EAKE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".todo-container {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.todo-header {\n  margin-bottom: 2rem;\n}\n\n.todo-header h2 {\n  margin: 0 0 0.5rem 0;\n  color: #333;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.todo-header p {\n  margin: 0;\n  color: #666;\n  font-size: 1rem;\n}\n\n.todo-submenu {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.todo-submenu-button {\n  padding: 0.75rem 1.5rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: #666;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: -2px;\n}\n\n.todo-submenu-button:hover {\n  color: #667eea;\n  background: #f5f5f5;\n}\n\n.todo-submenu-button.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n  font-weight: 600;\n}\n\n.todo-content {\n  width: 100%;\n}\n\n.todo-add-section {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding: 1rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.todo-add-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.2s ease;\n}\n\n.todo-add-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.todo-add-button {\n  padding: 0.75rem 2rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.todo-add-button:hover {\n  background: #5568d3;\n}\n\n.todo-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.todo-item {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease;\n  overflow: hidden;\n}\n\n.todo-item.expanded {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.todo-item.completed {\n  opacity: 0.8;\n  background: #f9f9f9;\n}\n\n.todo-item.changelog-item {\n  background: #f5f5f5;\n  border-left: 4px solid #667eea;\n}\n\n.todo-item-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.todo-item-header:hover {\n  background: #f9f9f9;\n}\n\n.todo-item-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.todo-item-checkbox {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #667eea;\n}\n\n.todo-item-title-wrapper {\n  flex: 1;\n  min-width: 0;\n}\n\n.todo-item-title-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.todo-item-title {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #333;\n  word-wrap: break-word;\n}\n\n.todo-item-date-inline {\n  font-size: 0.85rem;\n  color: #999;\n  font-style: italic;\n}\n\n.todo-item.completed .todo-item-title {\n  text-decoration: line-through;\n  color: #999;\n}\n\n.todo-item.changelog-item .todo-item-title {\n  text-decoration: none;\n  color: #333;\n}\n\n.todo-edit-title-input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 2px solid #667eea;\n  border-radius: 4px;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.todo-item-priority {\n  display: flex;\n  align-items: center;\n}\n\n.todo-priority-select {\n  padding: 0.5rem 1rem;\n  border: 2px solid #e0e0e0;\n  border-left: 4px solid #666;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.todo-priority-select:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.todo-item-actions {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.todo-edit-button,\n.todo-save-button,\n.todo-cancel-button,\n.todo-close-button,\n.todo-delete-button {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.todo-edit-button {\n  background: #667eea;\n  color: white;\n}\n\n.todo-edit-button:hover {\n  background: #5568d3;\n}\n\n.todo-save-button {\n  background: #4caf50;\n  color: white;\n}\n\n.todo-save-button:hover {\n  background: #45a049;\n}\n\n.todo-cancel-button {\n  background: #999;\n  color: white;\n}\n\n.todo-cancel-button:hover {\n  background: #777;\n}\n\n.todo-close-button {\n  background: #ff9800;\n  color: white;\n}\n\n.todo-close-button:hover {\n  background: #f57c00;\n}\n\n.todo-delete-button {\n  background: #d32f2f;\n  color: white;\n}\n\n.todo-delete-button:hover {\n  background: #b71c1c;\n}\n\n.todo-item-details {\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e0e0e0;\n  background: #fafafa;\n}\n\n.todo-item-description {\n  color: #666;\n  line-height: 1.6;\n}\n\n.todo-item-description p {\n  margin: 0;\n}\n\n.todo-no-description {\n  font-style: italic;\n  color: #999;\n}\n\n.todo-edit-description-input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #667eea;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.todo-edit-description-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.todo-changelog-details {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.todo-changelog-description {\n  color: #666;\n  line-height: 1.6;\n}\n\n.todo-changelog-description p {\n  margin: 0;\n}\n\n.todo-changelog-date {\n  font-size: 0.9rem;\n  color: #999;\n  font-style: italic;\n}\n\n.todo-empty-state {\n  text-align: center;\n  padding: 3rem 2rem;\n  color: #666;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.loading, .error {\n  text-align: center;\n  padding: 3rem 2rem;\n  font-size: 1.1rem;\n}\n\n.error {\n  color: #d32f2f;\n  background-color: #ffebee;\n  border-radius: 4px;\n  border: 1px solid #ffcdd2;\n}\n\n\n.todo-changelog-table {\n  table-layout: fixed;\n}\n\n@media (max-width: 768px) {\n  .todo-container {\n    padding: 1rem;\n  }\n\n  .todo-item-header {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .todo-item-actions {\n    flex-wrap: wrap;\n  }\n\n  .todo-priority-select {\n    font-size: 0.85rem;\n    padding: 0.4rem 0.8rem;\n  }\n}\n\n/* Changelog search */\n.changelog-search-container {\n  margin-bottom: 1.5rem;\n  padding: 0;\n}\n\n.changelog-search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-family: inherit;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.changelog-search-input:focus {\n  outline: none;\n  border-color: #667eea;\n}\n\n.changelog-search-input::placeholder {\n  color: #999;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
